import { fluidSprings } from "~/components/ui/fluid-motion";

/**
 * The center pill's identity motion, ported from v1 (whose center toast rode
 * on sonner): a ~400ms lift from below the stack's resting spot, and a
 * quicker slide-down fade on the way out. The 0.4s duration is a documented
 * exception to the fluid tiers — same spirit as the submitted checkmark —
 * because this is the toast's signature entrance, not layout motion. Bounce
 * stays 0 per the no-overshoot rule.
 */
export const TOAST_PILL_RISE = {
  type: "spring",
  duration: 0.4,
  bounce: 0,
} as const;

export const TOAST_PILL_ENTER_FROM = { opacity: 0, y: 24 } as const;

export const TOAST_PILL_EXIT = {
  opacity: 0,
  y: 24,
  transition: { duration: 0.18, ease: "easeIn" },
} as const;

/**
 * Stack reflows (fan-out, reorder, sibling removal) keep the standard fluid
 * tier — only mount/unmount get the long lift.
 */
export const TOAST_PILL_LAYOUT_TRANSITION = fluidSprings.moderate;

/**
 * The success pulse is a THREE-keyframe scale ([1, 1.04, 1]) and framer
 * REJECTS multi-keyframe values on spring transitions — it throws at
 * runtime, which kills the element's animation controller and blocks its
 * AnimatePresence exit forever (the "pill never leaves" bug). Scale must
 * therefore ride its own tween.
 */
export const TOAST_PILL_PULSE_TRANSITION = {
  duration: 0.35,
  ease: "easeOut",
} as const;
